import { ThemeOptions } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import * as React from 'react';

import { Link } from '../link';

export interface BreadcrumbItem {
    href: string;
    children: React.ReactNode;
    'aria-current'?: 'page';
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

export const BreadcrumbLink = (props: BreadcrumbItem) => {
    return (
        <Link
            href={props.href}
            aria-current={props['aria-current']}
            color="text.secondary"
            noWrap
            underline="hover"
            textTransform="sentence"
        >
            {props.children}
        </Link>
    );
};

export const Breadcrumbs = (props: BreadcrumbsProps) => {
    if (!props.items.length) {
        return null;
    }

    return (
        <MuiBreadcrumbs aria-label="breadcrumb">
            {props.items.map(({ href, children, ...linkProps }, index) => (
                <BreadcrumbLink
                    href={href}
                    key={href}
                    aria-current={
                        index === props.items.length - 1 ? 'page' : undefined
                    }
                    {...linkProps}
                >
                    {children}
                </BreadcrumbLink>
            ))}
        </MuiBreadcrumbs>
    );
};

export const breadcrumbsStyle = {
    MuiBreadcrumbs: {
        styleOverrides: {
            ol: { flexWrap: 'nowrap' }
        }
    }
} satisfies ThemeOptions['components'];
